
import Vue, { PropType } from 'vue';

export default Vue.extend({
    props: {
        ariaLabel: {
            type: String as PropType<string>,
            default: undefined
        }
    }
});
